import axios from 'axios';
import { environment } from '../../../environments/environment';

const service = axios.create({
  baseURL: environment.apiConfig.baseURL + '/api/',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 60000,
});

service.interceptors.request.use(
  function (config : any) {
    const originalRequest = config;
    // check public_chat_token first
    if (localStorage.getItem('public_chat_token')) {
      originalRequest.headers['Authorization'] = 'Bearer ' + localStorage.getItem('public_chat_token');
    } else {
      originalRequest.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
    }

    // originalRequest.headers['Authorization'] = 'Bearer ' + token;
    return Promise.resolve(originalRequest);
  },
  function (error) {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.error('error', error);
    if (localStorage.getItem('public_chat_token')) {
      localStorage.removeItem('public_chat_token');
      return Promise.reject(error.response);
    }
    const verifyFailed = new RegExp(/Verify Token is Failed./i);
    if (error && error.response) {
      if (error.response.data && verifyFailed.test(error.response.data.exception)) {
        window.location.href = 'auth/login';
        localStorage.removeItem('token');
      }

      if (error.response.status == 401 || error.response.statusText === 'Unauthorized') {
        const exception = new RegExp(/changeActiveCompany|deleteCompany/i);
        if (!exception.test(error.response.request.responseURL)) {
          window.location.href = 'auth/login';
          localStorage.removeItem('token');
        }
      }
      return Promise.reject(error.response);
    }
    console.trace("Timeout Error here");
    return Promise.reject('INTERNET_UNSTABLE');
  }
);

export default service;
